
import { orgConstants } from "../constants";

const docTypeSort = (x, y) => {
  let a = x.doc_type.toUpperCase();
  let b = y.doc_type.toUpperCase();
  return a == b? 0: a > b? 1 : -1;
} 


export function org(state = [], action) {
  switch (action.type) {
    case orgConstants.ORG_GETLIST_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case orgConstants.ORG_GETLIST_SUCCESS:
      return {
        ...state,
        list: action.list,
        isLoading: false,
      };
    case orgConstants.ORG_GETLIST_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case orgConstants.ORG_SET_CURRENT_ORG_ID:
      return {
        ...state,
        current_org_id: Number(action.org_id),
        isLoading: false,
      };
    case orgConstants.ORG_CREATE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case orgConstants.ORG_CREATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case orgConstants.ORG_CREATE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
      case orgConstants.ORG_EDIT_REQUEST:
        return {
          ...state,
          isLoading: true,
          editRequest: 'started',
        };
      case orgConstants.ORG_EDIT_SUCCESS:
        return {
          ...state,
          isLoading: false,
          editRequest: 'completed'
        };
      case orgConstants.ORG_EDIT_FAILURE:
        return {
          ...state,
          error: action.error,
          isLoading: false,
          editRequest: 'error',
        };     
      case orgConstants.ORG_EDIT_RESET:
          return {
            ...state,
            error: action.error,
            isLoading: false,
            editRequest: null,
          };           
    case orgConstants.ORG_ORGTYPES_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case orgConstants.ORG_ORGTYPES_SUCCESS:
      return {
        ...state,
        org_types: action.list,
        isLoading: false,
      };
    case orgConstants.ORG_ORGTYPES_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case orgConstants.ORG_INGESTION_STATS_REQUEST:
      return {
        ...state,
        ingestion_stats: null,
        isLoading: true,
      };
    case orgConstants.ORG_INGESTION_STATS_SUCCESS:
      return {
        ...state,
        ingestion_stats: action.list,
        isLoading: false,
      };
    case orgConstants.ORG_INGESTION_STATS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case orgConstants.ORG_INGESTION_STATS_CLEAR:
      return {
        ...state,
        ingestion_stats: null,
        isLoading: false,
      };
    case orgConstants.ORG_SCRAPE_INFO_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case orgConstants.ORG_SCRAPE_INFO_SUCCESS:
      return {
        ...state,
        scrape_info: action.info,
        isLoading: false,
      };
    case orgConstants.ORG_SCRAPE_INFO_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case orgConstants.ORG_OCR_INFO_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case orgConstants.ORG_OCR_INFO_SUCCESS:
      return {
        ...state,
        ocr_info: action.info,
        isLoading: false,
      };
    case orgConstants.ORG_OCR_INFO_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case orgConstants.ORG_GET_ORG_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case orgConstants.ORG_GET_ORG_LIST_SUCCESS:
      return {
        ...state,
        org_list: action.list,
        isLoading: false,
      };
    case orgConstants.ORG_GET_ORG_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case orgConstants.ORG_GET_ORG_DETAIL_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case orgConstants.ORG_GET_ORG_DETAIL_SUCCESS:
      return {
        ...state,
        org_detail: action.org,
        isLoading: false,
      };
    case orgConstants.ORG_GET_ORG_DETAIL_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case orgConstants.ORG_GET_ORG_USERS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case orgConstants.ORG_GET_ORG_USERS_SUCCESS:
      return {
        ...state,
        org_users: action.users,
        isLoading: false,
      };
    case orgConstants.ORG_GET_ORG_USERS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
      case orgConstants.ORG_GET_DOC_TYPES_REQUEST:
        return {
          ...state,
          isLoading: true,
        };
      case orgConstants.ORG_GET_DOC_TYPES_SUCCESS:
        return {
          ...state,
          doc_types: action.doctypes,
          isLoading: false,
        };
      case orgConstants.ORG_GET_DOC_TYPES_FAILURE:
        return {
          ...state,
          error: action.error,
          isLoading: false,
        };     
      case orgConstants.ORG_CREATE_DOCTYPE_REQUEST:
        return {
          ...state,
          doc_types: [...state.doc_types, action.docTypeRequest].sort(docTypeSort),
          isLoading: true,
        };
      case orgConstants.ORG_CREATE_DOCTYPE_SUCCESS:
        return {
          ...state,
          isLoading: false,
        };
      case orgConstants.ORG_CREATE_DOCTYPE_FAILURE:
        return {
          ...state,
          error: action.error,
          isLoading: false,
        };     
        case orgConstants.ORG_EDIT_DOCTYPE_REQUEST:
          return {
            ...state,
            isLoading: true,
            editDoctypeRequest: 'started',
          };
        case orgConstants.ORG_EDIT_DOCTYPE_SUCCESS:
          return {
            ...state,
            isLoading: false,
            editDoctypeRequest: 'completed'
          };
        case orgConstants.ORG_EDIT_DOCTYPE_FAILURE:
          return {
            ...state,
            error: action.error,
            isLoading: false,
            editDoctypeRequest: 'error',
          };     
        case orgConstants.ORG_EDIT_DOCTYPE_RESET:
            return {
              ...state,
              error: action.error,
              isLoading: false,
              editDoctypeRequest: null,
            };               
            case orgConstants.ORG_DELETE_DOCTYPE_REQUEST:
              return {
                ...state,
                isLoading: true,
                deleteDoctypeRequest: 'started',
              };
            case orgConstants.ORG_DELETE_DOCTYPE_SUCCESS:
              return {
                ...state,
                isLoading: false,
                deleteDoctypeRequest: 'completed'
              };
            case orgConstants.ORG_DELETE_DOCTYPE_FAILURE:
              return {
                ...state,
                error: action.error,
                isLoading: false,
                deleteDoctypeRequest: 'error',
              };     
            case orgConstants.ORG_DELETE_DOCTYPE_RESET:
                return {
                  ...state,
                  error: action.error,
                  isLoading: false,
                  deleteDoctypeRequest: null,
                };                 
    default: {
      return state;
    }
  }
}
